export const tableHeaders = ["Name", "Last Price", "Change", "Market cap"];
